
// src/components/SettingsPanel.js
import React, { useState } from 'react';
import '../styles/SettingsPanel.css';

const SettingsPanel = ({ settings, onApply }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [layerSettings, setLayerSettings] = useState({ ...settings });
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setLayerSettings(prev => {
      const newSettings = { ...prev };
      
      if (name === 'minDepth' || name === 'maxDepth') {
        newSettings[name] = parseInt(value, 10);
      } else {
        newSettings[name] = parseFloat(value);
      }
      
      return newSettings;
    });
  };
  
  const handleApply = () => {
    onApply(layerSettings);
    showFeedback();
  };
  
  const showFeedback = () => {
    const feedbackElement = document.getElementById('settings-feedback');
    if (feedbackElement) {
      feedbackElement.style.opacity = '1';
      setTimeout(() => {
        feedbackElement.style.opacity = '0';
      }, 2000);
    }
  };

  return (
    <>
      {!isOpen && (
        <button className="show-settings-btn" onClick={() => setIsOpen(true)}>
          設定
        </button>
      )}
      
      <div className={`settings-panel ${isOpen ? 'open' : ''}`}>
        <h3>レイヤー設定</h3>
        <button 
          className="toggle-settings-btn" 
          onClick={() => setIsOpen(false)}
        >
          ×
        </button>
        
        <div className="settings-group">
          <label htmlFor="minDepth">最奥レイヤーの深度 (px)</label>
          <input 
            type="range" 
            id="minDepth" 
            name="minDepth"
            min="-800" 
            max="-100" 
            step="10"
            value={layerSettings.minDepth} 
            onChange={handleChange}
          />
          <span>{layerSettings.minDepth}</span>
        </div>
        
        <div className="settings-group">
          <label htmlFor="maxDepth">最前レイヤーの深度 (px)</label>
          <input 
            type="range" 
            id="maxDepth" 
            name="maxDepth"
            min="-50" 
            max="50" 
            step="5"
            value={layerSettings.maxDepth} 
            onChange={handleChange}
          />
          <span>{layerSettings.maxDepth}</span>
        </div>
        
        <div className="settings-group">
          <label htmlFor="minScale">最前面スケール</label>
          <input 
            type="range" 
            id="minScale" 
            name="minScale"
            min="0.5" 
            max="1.5" 
            step="0.05"
            value={layerSettings.minScale} 
            onChange={handleChange}
          />
          <span>{layerSettings.minScale.toFixed(2)}</span>
        </div>
        
        <div className="settings-group">
          <label htmlFor="maxScale">最背面スケール</label>
          <input 
            type="range" 
            id="maxScale" 
            name="maxScale"
            min="1.0" 
            max="2.0" 
            step="0.05"
            value={layerSettings.maxScale} 
            onChange={handleChange}
          />
          <span>{layerSettings.maxScale.toFixed(2)}</span>
        </div>
        
        <button 
          className="apply-settings-btn"
          onClick={handleApply}
        >
          適用
        </button>
        
        <div id="settings-feedback" className="settings-feedback">
          設定を適用しました
        </div>
      </div>
    </>
  );
};

export default SettingsPanel;